<script setup lang="ts">
import type { DRLocalDrawingMeta, DRDrawing } from "@/types";
import HomepageSection from "./HomepageSection.vue";
import { computed } from "vue";
import DrawingItem from "../files/DrawingList/DrawingItem.vue";
import { useGetLastDrawings } from "@/stores/queries";
import { getLastEditedDate } from "@/utils/drawings.utils";
import { useDrawingStore } from "@/stores/fileStore";

const drawingStore = useDrawingStore();

const lastLocalDataIds = computed<number[]>(() => {
  const res: DRLocalDrawingMeta[] = drawingStore.localDrawings ?? [];
  res.sort((a, b) => {
    const aDate = getLastEditedDate(a);
    const bDate = getLastEditedDate(b);
    if (!aDate) return -1;
    if (!bDate) return 1;
    return bDate > aDate ? 1 : -1;
  });
  return res.map((drawing) => drawing.id).filter((id) => id > 0);
});

const { data } = useGetLastDrawings(lastLocalDataIds);

const drawings = computed(() => {
  return data.value?.drawings?.slice(0, 6) ?? [];
});
</script>

<template>
  <HomepageSection
    :label="$t('dashboard:homepage.last-drawings')"
    :item-key="(item: DRDrawing) => item.id"
    :items="drawings"
    :empty-text="$t('dashboard:homepage.no-recent-drawings')"
  >
    <template #item="{ item, display }">
      <DrawingItem :drawing="item" disable-select :display="display" />
    </template>
  </HomepageSection>
</template>

<style lang="scss" scoped></style>
